import { memo, useContext } from 'react';

import PersonInPlaceEditor from '@/components/PersonInPlaceEditor/PersonInPlaceEditor';
import { FieldTypes } from '@/components/PersonInPlaceEditor/types';
import PersonContext from '@/pages/Person/PersonContext';
import SectionHeading from '@/pages/Profile/components/SectionHeading';
import { DataRow } from '@/ui/components/DataList';
import DataList from '@/ui/components/DataList/DataList';

const AdminSection = () => {
  const {
    person: { exclude_from_analytics, exclude_from_cm_payments }
  } = useContext(PersonContext);

  return (
    <div className="relative">
      <SectionHeading text="Admin" />

      <PersonInPlaceEditor
        sectionEditor
        fields={[
          {
            key: 'exclude_from_analytics',
            label: 'Exclude from Analytics',
            type: FieldTypes.BOOLEAN
          },
          {
            key: 'exclude_from_cm_payments',
            label: 'Exclude from CM Payments',
            type: FieldTypes.BOOLEAN
          }
        ]}>
        <DataList>
          <DataRow label="Exclude from Analytics">{exclude_from_analytics ? 'Yes' : 'No'}</DataRow>
          <DataRow label="Exclude from CM Payments">
            {exclude_from_cm_payments ? 'Yes' : 'No'}
          </DataRow>
        </DataList>
      </PersonInPlaceEditor>
    </div>
  );
};

export default memo(AdminSection);
